import React, { useState, useEffect } from 'react';

const SectionNavigator = () => {
  const [activeSection, setActiveSection] = useState('content');

  const sections = [
    { id: 'content', label: 'Content Type' },
    { id: 'input', label: 'Input Data' },
    { id: 'customize', label: 'Customize' },
    { id: 'preview', label: 'Preview' },
    { id: 'export', label: 'Export' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 120;
      
      for (const section of sections) {
        const element = document.getElementById(section?.id);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section?.id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element?.getBoundingClientRect()?.top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className="lg:hidden sticky top-16 z-50 bg-card border-b border-border shadow-warm-sm">
      <div className="overflow-x-auto scrollbar-custom">
        <div className="flex gap-2 px-4 py-3 min-w-max">
          {sections?.map((section) => (
            <button
              key={section?.id}
              onClick={() => scrollToSection(section?.id)}
              className={`
                px-4 py-2 rounded-lg font-caption text-sm font-medium whitespace-nowrap
                transition-smooth
                ${activeSection === section?.id
                  ? 'bg-accent text-accent-foreground shadow-warm-sm'
                  : 'bg-muted text-muted-foreground hover:bg-muted/80'
                }
              `}
            >
              {section?.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default SectionNavigator;